<template>
  <div>
    <!-- hero -->
    <div class="page-wrapper pt-0 pb-0">
      <hero
        :show-sign-up="true"
        :full-screen="false"
        :title="[
          {
            value:
              'Bulletin is a premium commerce community where retailers discover, meet, and shop the best brands on the planet.'
          }
        ]"
        :copy="[{ value: 'Join our community' }]"
        :image-url="require('../../assets/img/home/visitor-hero.jpg')"
        :mobi-image-url="require('../../assets/img/home/visitor-hero-mobi.jpg')"
        :background-color="'#e1ffa1'"
      />
    </div>
    <div id="features" class="pb-30 pt-10 bt bb">
      <div class="container home-page">
        <div class="grid-12">
          <div class="span-4 text-center px-10 span-12-md mb-30-md flex flex-direction-column items-center">
            <Icon icon-key="ribbon" :size="75" />
            <h4>Premium Partners</h4>
            <p class="font-size-18 mt-10">
              We only stock the best. Shop thousands of brands vetted for quality and reliability.
            </p>
          </div>
          <div class="span-4 span-12-sm mb-30-sm px-10 flex flex-direction-column items-center">
            <Icon icon-key="hearts" :size="75" />
            <h4>Community</h4>
            <p class="font-size-18 mt-10 text-center">
              Create a custom feed of the brands you want to meet, message, and order from.
            </p>
          </div>
          <div class="span-4 text-center px-10 span-12-md flex flex-direction-column items-center">
            <Icon icon-key="calendar" :size="75" />
            <h4>Net 60 Payment Terms</h4>
            <p class="font-size-18 mt-10">
              Sell your inventory for two full months before paying the wholesale invoice.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- featured brands -->
    <div class="page-wrapper page-wrapper--grey bb pt-70 pb-70 pt-30-sm pb-70-sm">
      <div class="container home-page">
        <featured :is-user-logged="false" />
      </div>
    </div>

    <home-page-carousel :data-provider="fetchMapCollectionsToCarouselItems" class="bg-green" title="Perfect for the" />

    <!-- new arrivals -->
    <div class="page-wrapper page-wrapper--white pb-130 pt-30-sm pb-30-sm">
      <div class="container home-page">
        <h4 class="mb-30">new arrivals</h4>
        <featured-brands />
      </div>
    </div>
    <!-- about -->
    <about :title="about.title" :copy="about.copy" />
    <!-- Best Sellers -->
    <div class="page-wrapper page-wrapper--white pb-130 pt-30-sm pb-90-sm">
      <div class="container home-page text-center">
        <headline :title="'Best Sellers'" class="mb-30-sm" />
        <best-sellers :is-user-logged="false" />
      </div>
    </div>

    <div class="py-40 bt">
      <div class="container home-page text-center">
        <h2>
          Wholesale made simple. <br />
          Apply now to join the community &mdash;
        </h2>
        <router-link :to="{ name: 'buyer' }" class="entity-image-link mt-30 mr-30">
          <entity-image
            v-trackevent="{ action: 'Homepage Retailer Application Bottom' }"
            type="retailer"
            size="lg"
            class="width-auto"
            :src="require('../../assets/img/value-props/retailers-2.png')"
          />
          <h4 class="mb-5 mt-20">I'm a</h4>
          <h1 class="font-size-36">Retailer</h1>
        </router-link>
        <router-link :to="{ name: 'Brand' }" class="entity-image-link mt-30">
          <entity-image
            v-trackevent="{ action: 'Homepage Brand Application Bottom' }"
            type="brand"
            size="lg"
            class="width-auto"
            :src="require('../../assets/img/value-props/retailers-1.png')"
          />
          <h4 class="mb-5 mt-20">I'm a</h4>
          <h1 class="font-size-36">Brand</h1>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Featured from './featured/featured.vue'
import FeaturedBrands from './featuredBrands/featuredBrands.vue'
import BestSellers from './bestSellers/bestSellers.vue'
import Hero from './hero/hero.vue'
import About from './about/about.vue'
import CMSAPI from '../../services/api/contentManagmentApi'
import { homePageHelper } from '../../components/mixin/homePageHelper'
import HomePageCarousel from './homePageCarousel/homePageCarousel.vue'

const { getHero, getAbout } = new CMSAPI()
export default {
  components: {
    HomePageCarousel,
    Hero,
    FeaturedBrands,
    Featured,
    BestSellers,
    About
  },
  mixins: [homePageHelper],
  data() {
    return {
      hero: {},
      about: {}
    }
  },
  beforeMount() {
    getHero()
      .then((response) => {
        const heroData = response.data[0]
        this.hero = {
          ...heroData,
          h1Array: heroData.h1.split('_%_').map((value) => ({
            value: value
          })),
          by_lineArray: heroData.by_line.split('_%_').map((value) => ({
            value: value
          }))
        }
      })
      .catch((error) => this.$handleError(this, error))
    getAbout()
      .then((response) => {
        this.about = response.data[0]
      })
      .catch((error) => this.$handleError(this, error))
  }
}
</script>
